<template>
    <div>
        <table class="table table-bordered table-responsive">
            <thead>
                <tr>
                    <th>File Name</th>
                    <th>Date</th>
                    <th>Uploaded By</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in soi" :key="item.id">
                    <td>{{ item.fileName }}</td>
                    <td>{{ item.lastModifiedDate | soiDate }}</td>
                    <td>{{ item.uploadedBy}}</td>
                    <td>
                        <TheDropDownButton>
                            <TheIconButton  @click.native="
                  downloadsoi(item.id, item.fileName, item.fileType, item.entryId)
                "
                                           icon="fa fa-download"
                                           title="Downloadable Profile"></TheIconButton>
                            <!-- put a delete button for crad users -->
                            <TheIconButton v-if="$store.getters.CRAD && item.canDelete"
                                           @click.native="deleteSOI(item.id, item.fileName, item.entryId)"
                                           icon="fa fa-trash"
                                           title="Delete Profile"></TheIconButton>
                        </TheDropDownButton>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
    import {
        authHeader,
        responseCheck,
        RecordURL,
        notifyHelper,
        downloadblob,
        EncodeURL,
    } from "../../helper";
    import TheIconButton from "../buttons/iconButton";
    import instance from "../../helper/http";
    export default {
        data() {
            return {
                soi: [],
            };
        },
        props: {
            id: {
                type: String,
                required: true,
            },
        },
        mounted: function () {
            this.sois();
        },
        components: {
            TheIconButton,
        },
        methods: {
            sois: function () {
                let loader = this.$loading.show();
                instance
                    .get(RecordURL + "soi?pID=" + this.id, {
                        headers: authHeader(),
                    })
                    .then((response) => {
                        if (response.data.withsoi) {
                            this.soi = response.data.data;
                            loader.hide();
                            //fireup modal
                            //this.showModal();
                        } else {
                            loader.hide();
                            notifyHelper("warn", "SOI files not found");
                        }
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            downloadsoi: function (folder, file, type, entryId) {
                let loader = this.$loading.show();
                instance
                    .get(RecordURL + "downloadsoi?folder=" + folder + "&filename=" + file + "&EntryId=" + entryId, {
                        headers: authHeader(),
                        responseType: "blob",
                    })
                    .then((response) => {
                        downloadblob(file, response.data, type);
                        loader.hide();
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            deleteSOI: function (iD, fileName, entryId) {
                if (confirm("are you sure you want to delete?")) {
                    instance
                        .get(EncodeURL + "deleteSOI?iD=" + iD + "&fileName=" + fileName + "&EntryId=" + entryId, {
                            headers: authHeader(),
                        })
                        .then((response) => {
                            if (response.data.error) {
                                notifyHelper("error", response.data.message);
                            } else {
                                notifyHelper("success", response.data.message);
                            }
                        })
                        .catch(function (error) {
                            responseCheck(error.response.status);
                        });
                }
            },
        },
    };
</script>

